import {TEntity} from 'modules/data/data-types';
import { ERequestType } from 'shared/types/requests';
import {performRequest} from 'shared/utils';

export type TFetchOpenInterfaceParams = {
  scenarioId: number;
  loadId: number;
  srcId?: number;
};

export const fetchOpenInterface = (
    {scenarioId, srcId, loadId}: TFetchOpenInterfaceParams,
) => performRequest<TEntity[]>({
    url: '/open-interface/get-open-interface',
    params: {
        scenarioId,
        loadId,
        srcId,
    },
    method: ERequestType.POST,
});

export type TClearStageParams = {
  userName: string;
  loadId: number;
};

export const clearStage = (
    {userName, loadId}: TClearStageParams,
) => performRequest<void>({
    url: '/open-interface/run-clear-open-interface',
    data: {
        loadId,
        userName,
    },
    method: ERequestType.POST,
});
